module.exports = __webpack_public_path__ + "img/shutterstock_416638408.a6543645.png";